import { z } from "zod";

import { dateValidator } from "@/lib/validators";

export const weightScaleBreakdown = z.object({
  mixedWaste: z
    .array(
      z.object({
        wasteTypeId: z.string().optional(),
        wasteName: z.string().optional(),
        percentage: z.coerce.number().max(100).optional(),
      }),
    )
    .optional(),
  otherWaste: z
    .array(
      z.object({
        wasteTypeId: z.string().optional(),
        wasteName: z.string().optional(),
      }),
    )
    .optional(),
});

export const weighScaleNewTicket = z.object({
  date: dateValidator(true, "Date is Required"),
  customerId: z.string().min(1, "Required"),
  projectId: z.string().min(1, "Required"),
  items: z
    .array(
      z.object({
        id: z.string().optional(),
        loadType: z.object({
          id: z.string(),
          quantity: z.coerce.number().min(1, {
            message: "Required",
          }),
          loadLimit: z.coerce.number().optional(),
        }),
        wasteType: z.object({
          id: z.string(),
          weight: z.coerce.number(),
        }),
        breakDown: weightScaleBreakdown.optional(),
      }),
    )
    .superRefine((data, ctx) => {
      if (data.length === 0) {
        ctx.addIssue({
          path: [],
          code: z.ZodIssueCode.custom,
          message: "At least one item is required.",
          fatal: true,
        });
      }
      // Check the first item in the array
      const [firstItem] = data;

      if (firstItem.loadType.quantity === 0) {
        ctx.addIssue({
          path: [0, "loadType", "quantity"],
          code: z.ZodIssueCode.custom,
          message: "Required",
          fatal: true,
        });
      }
      if (firstItem.loadType.id === "") {
        ctx.addIssue({
          path: [0, "loadType", "id"],
          code: z.ZodIssueCode.custom,
          message: "Required",
          fatal: true,
        });
      }

      if (firstItem.wasteType.id === "") {
        ctx.addIssue({
          path: [0, "wasteType", "id"],
          code: z.ZodIssueCode.custom,
          message: "Required",
          fatal: true,
        });
      }

      if (firstItem.wasteType.weight === 0) {
        ctx.addIssue({
          path: [0, "wasteType", "weight"],
          code: z.ZodIssueCode.custom,
          message: "Required",
          fatal: true,
        });
      }
    }),
});

export type TWeighScaleNewTicket = z.infer<typeof weighScaleNewTicket>;

export const weighScaleUpdateTicket = weighScaleNewTicket.extend({
  ticketNumber: z.union([z.string(), z.number()]).optional(),
  deleteItems: z.array(z.string()).optional(),
});

export type TWeighScaleUpdateTicket = z.infer<typeof weighScaleUpdateTicket>;
export type TWeightScaleBreakdown = z.infer<typeof weightScaleBreakdown>;
